export const CONNECTION_PRESENTATION_ORDER = [
    'orbit',
    'orbitWithArrow',
    'arrow',
    'hidden',
];
export const DEFAULT_PRESENTATION_ARROW_PROFILE = {
    style: { color: 0xffc95c, widthPx: 6, opacity: 0.95 },
    arrows: { end: true, size: 28, facing: 'towardTarget' },
    elastic: { enabled: false },
};
function getOrbIdentifier(orb) {
    var _a, _b, _c, _d, _e;
    return ((_e = (_d = (_c = (_b = (_a = orb.group) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : orb.uuid) !== null && _c !== void 0 ? _c : orb.id) !== null && _d !== void 0 ? _d : orb.labelText) !== null && _e !== void 0 ? _e : 'orb');
}
export function resolvePresentationModeFlags(mode) {
    switch (mode) {
        case 'orbitWithArrow':
            return { orbit: true, arrow: true, hideChild: false };
        case 'arrow':
            return { orbit: false, arrow: true, hideChild: true };
        case 'hidden':
            return { orbit: false, arrow: false, hideChild: true };
        default:
            return { orbit: true, arrow: false, hideChild: false };
    }
}
export function getPresentationProfileName(parent, child) {
    const parentId = getOrbIdentifier(parent);
    const childId = getOrbIdentifier(child);
    return `presentation:${parentId}:${childId}`;
}
export function makePresentationStateKey(a, b) {
    const ids = [getOrbIdentifier(a), getOrbIdentifier(b)].sort();
    return ids.join('::');
}
